<script>
    import { onMount } from "svelte";
    import { querystring, location, pop, replace } from "svelte-spa-router";
    import { Icon, Container, Row, Col, ButtonToolbar, Button } from "sveltestrap";

    import helpers from "@/libs/helpers/index.js";
    import { storeConfig, storeLang, storePages, storeLocalesViews } from "@/stores/config.store";

    $: isReady = localesView;

    const view = "page";
    $: localesView = $storeLocalesViews[view];
    onMount(() => {
        const file = $storeConfig.views[view].locales[$storeLang];
        storeLocalesViews.setLocalesView(view, file);
        loadPage();
    });

    let content = "Paramètre 'page' non définie";
    function loadPage() {
        const page = helpers.getUrlParameter($querystring, "page", false);
        const file = $storePages[page];
        if (file) {
            helpers.getFile(file).then((response) => {
                content = helpers.toHtml(response.data);
            });
        }
    }

    function goBack() {
        pop();
    }
</script>

{#if isReady}
    <Container class="mt-3">
        <Row class="">
            <Col>
                {@html content}
            </Col>
        </Row>
        <Row>
            <Col>
                <ButtonToolbar class="float-end mt-3">
                    <Button outline color="dark" class="me-3" on:click={goBack}>
                        <Icon name="caret-left" />
                        Retour
                    </Button>
                </ButtonToolbar>
            </Col>
        </Row>
    </Container>
{/if}
